/* File generated by vital-package-manager. DO NOT EDIT! */

import './post-grid/index';
import './filter-bar-ui-controller';



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/index.js